import { render, staticRenderFns } from "./SelectSalesGroup.vue?vue&type=template&id=345c18c3&"
import script from "./SelectSalesGroup.vue?vue&type=script&lang=js&"
export * from "./SelectSalesGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports